import americanexpress from './american-express.svg';
import mastercard from './mastercard.svg';
import visa from './visa.svg';

export default { americanexpress, mastercard, visa };
